import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export default function AppBridgeProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const router = useRouter()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // During SSR, just render children
  if (!isClient) {
    return <>{children}</>
  }

  if (!router.isReady) {
    return null
  }

  // On client side, check for shop parameter
  const shop = router.query.shop as string
  const allowsMissingShop = router.pathname === '/integrations/yuzu/setup'

  if (!(shop || allowsMissingShop)) {
    return <p>No Shop Provided</p>
  }

  return <>{children}</>
}
